// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const onlymotorsColors: ColorType = {
  ...colorPalette,
  primary: '#FFFFFF',
  secondary: '#FFFFFF',
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
}

export const darkTheme = {
  colors: onlymotorsColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: onlymotorsColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: onlymotorsColors.primaryGray,
    secondary: onlymotorsColors.secondaryGray,
    disabled: onlymotorsColors.grayText,
    link: onlymotorsColors.secondaryGray,
    hint: onlymotorsColors.white,
    highlight: onlymotorsColors.secondary,
    gray: onlymotorsColors.primaryGray,
    seeAll: onlymotorsColors.secondaryGray,
    primaryContrast: '#000000',
  },
  border: {
    primary: onlymotorsColors.primaryGray,
    gray: onlymotorsColors.secondaryGray,
  },
  filter: {
    primary: onlymotorsColors.primaryGray,
    secondary: onlymotorsColors.secondaryGray,
    disabled: onlymotorsColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: onlymotorsColors.dark,
    color: onlymotorsColors.white,
    border: onlymotorsColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: onlymotorsColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: onlymotorsColors.dark,
        selected: onlymotorsColors.dark,
        progress: rgba(onlymotorsColors.primary, 0.3),
        past: rgba(onlymotorsColors.primary, 0.3),
        pastSelected: onlymotorsColors.dark,
        pastHover: onlymotorsColors.dark,
        empty: '#555555',
        emptyProgress: rgba(onlymotorsColors.primary, 0.1),
      },
      text: {
        empty: onlymotorsColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: onlymotorsColors.white,
    subTitle: onlymotorsColors.secondaryGray,
    bg: onlymotorsColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
